import '@google/model-viewer/lib/model-viewer';
import ModelViewer from './components/model-viewer';

const modelViewer = new ModelViewer();
modelViewer.init();
